import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  index(params) {
    const url = `${window.api_url}/shared/question_sets`;
    return axios.get(url, { params }).catch(handleError);
  },
};
